import { TmcContextService } from './../../../../../common/tmc-context.service';
import { ResponseMessage } from '@sdbn/common';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Component, Inject, OnDestroy } from '@angular/core';
import { TransportOption, TransportOptionColumn, TransportOptionSelection, TransportOptionsPanelModel } from '../../../../../components/transport-options-panel/transport-options-panel.model';
import { YardConfiguration } from '../../../../../client/model/yard-configuration';

import { ForwardToProcess } from '../../model/sac-client.model';
import { FormControl, FormGroup } from '@angular/forms';

export class TransportOptionSelectionDialogData {
  carrier: string;
  driver: string;
  identifier: string;
  transportScope: any;
  responseMessages: ResponseMessage[];
  // callback: (selectedOptionIds: Array<number>) => void;
}


@Component({
    selector: 'app-transport-option-selection',
    templateUrl: './transport-option-selection.component.html',
    styleUrls: ['./transport-option-selection.component.scss'],
    standalone: false
})
export class TransportOptionSelectionComponent implements OnDestroy {

  model: TransportOptionsPanelModel;
  validStateSubscription: Subscription;
  selectionChangeSubscription: Subscription;


  tmcContextSubscription: Subscription;
  yardConfiguration: YardConfiguration;

  selectedOptionIds = new Array<number>();

  isConfirmDisabled = true;

  vehicleFormGroup = new FormGroup({
    useAsVehicle: new FormControl(null, [])
  })

  constructor(
    public dialogRef: MatDialogRef<TransportOptionSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TransportOptionSelectionDialogData,
    public dialog: MatDialog,
    private tmcContextService: TmcContextService
  ) {

    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(next => {
      if (next != null) {
        this.yardConfiguration = next;
        this.createTransportOptionsModel();
      }
    });
  }

  ngOnDestroy() {
    if (this.validStateSubscription != null) {
      this.validStateSubscription.unsubscribe();
      this.validStateSubscription = null;
    }
    if (this.selectionChangeSubscription != null) {
      this.selectionChangeSubscription.unsubscribe();
      this.selectionChangeSubscription = null;
    }
    if (this.tmcContextSubscription != null) {
      this.tmcContextSubscription.unsubscribe();
      this.tmcContextSubscription = null;
    }
  }

  public cancelDialog() {
    this.dialogRef.close(null);
  }

  public confirm() {
    this.dialogRef.close(new ForwardToProcess({ selectedOptionIds: this.selectedOptionIds, asVehicle: this.vehicleFormGroup.controls['useAsVehicle'].value }));
  }

  private createTransportOptionsModel() {

    if (this.validStateSubscription != null) {
      this.validStateSubscription.unsubscribe();
    }
    if (this.selectionChangeSubscription != null) {
      this.selectionChangeSubscription.unsubscribe();
    }

    if (this.yardConfiguration != null) {
      let columns = new Array<TransportOptionColumn>();
      for (let option of this.yardConfiguration.transportOptions) {
        while (option.columnIndex != null && columns.length < option.columnIndex + 1) {
          let column = new TransportOptionColumn();
          columns.push(column);
        }
        let column = columns[option.columnIndex];
        column.options.push(new TransportOption(option));
      }

      this.model = new TransportOptionsPanelModel(
        {
          columns: columns,
          constraints: this.yardConfiguration.transportOptionConstraints,
          selection: new Array<TransportOptionSelection>()
        }
      );
      this.validStateSubscription = this.model.validState.subscribe(valid => {
        this.updateEnablement();
      });

      this.selectionChangeSubscription = this.model.selectionChange.subscribe(value => {

        const newSelection = new Array<number>();
        for (const selection of this.model.getOnlySelectedTransportOptionSelection()) {
          newSelection.push(selection.id);
        }
        this.selectedOptionIds = newSelection;
      });
    }
  }

  private updateEnablement() {
    this.isConfirmDisabled = !this.model.valid;
  }
}
